export default __webpack_public_path__ + "static/3-9c332abfd999531d89db310bbcc35167.jpg";